// Common icon names used across the application
export enum IconName {
  // Navigation icons
  Play = "play",
  Home = "home",
  List = "list",
  Help = "help",
  HelpCircle = "help-circle", 
  Archive = "archive",
  More = "more",
  MoreHorizontal = "more-horizontal",
  
  // Game/content icons
  Trophy = "trophy",
  Award = "award",
  User = "user",
  Leaderboard = "leaderboard",
  Star = "star",
  Store = "store",
  
  // Default fallback
  Circle = "circle"
}

/**
 * Maps icon names to their corresponding Lucide React components
 */
export const ICON_COMPONENT_MAP = {
  [IconName.Play]: "Play",
  [IconName.Home]: "Home",
  [IconName.List]: "List",
  [IconName.Help]: "HelpCircle", 
  [IconName.HelpCircle]: "HelpCircle",
  [IconName.Archive]: "Archive",
  [IconName.More]: "Ellipsis",
  [IconName.MoreHorizontal]: "Ellipsis", 
  [IconName.Trophy]: "Trophy",
  [IconName.Award]: "Award",
  [IconName.User]: "User", 
  [IconName.Leaderboard]: "BarChart3",
  [IconName.Star]: "Star",
  [IconName.Store]: "Store",
  [IconName.Circle]: "Circle"
} as const;
